<template>
  <div v-if="moisture_value" class="sensor-readings">
      <p v-if="moisture_value">
          Soil Moisture: {{ moisture_value }}%
      </p>
      <p v-if="temperature_c_value">
          Temperature: {{ temperature_c_value }}&#x2103;
      </p>
      <p v-if="humidity_perc_value">
          Humidity: {{ humidity_perc_value }}%
      </p>
  </div>

  <div v-else>Loading...</div>
</template>

<script>
export default {
  name: "SensorReadings",
  props: ["moisture_value", "humidity_perc_value", "temperature_c_value"]
};
</script>

<style scoped>
.sensor-readings {
  background-color: #eeeeee;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  width: 20em;
  padding-top: 20px;
  padding-bottom: 20px;

  border-radius: 4px;
  border-color: #dddddd;
  border-width: 1px;
  border-style: solid;

  font-family: "Courier New", Courier, monospace;
}
</style>